import React, { useState } from "react";
import { Spinner } from "../../../../components/spinner";
import { UpdateContactDetailsTypes } from "../../UpdateContactDetailsTypes";
import { UpdateDetailsErrorScreen } from "../ErrorScreens/UpdateDetailsErrorScreen";
import { UpdateContactDetails } from "../UpdateContactDetails/UpdateContactDetails";
// import { UpdateNotifications } from '../UpdateNotifications';
import { navigate } from "gatsby";
import { updateTenant } from "@codeparva/v11-tfw-api-library";

export const UpdateTenantContactDetailsPage = ({
  tenantData,
  facilityId,
  tenantToken
}: UpdateContactDetailsTypes.TUpdateContactDetailsPage) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);

  const currPage = location.pathname.substring(
    0,
    location.pathname.lastIndexOf("/")
  );

  const showErrorScreen = () => {
    if (hasError) {
      return (
        <UpdateDetailsErrorScreen
          setError={setHasError}
          setLoading={setIsLoading}
        />
      );
    }

    return (
      <div className="loaderParent">
        <Spinner />
      </div>
    );
  };

  const {
    address,
    email,
    name,
    phone,
    id: tenantId,
    other_address = {}
  } = tenantData;

  const callBackHandler = async (updateRequest: any) => {
    setIsLoading(true);
    const [updateContactDetailsErr] = await updateTenant({
      updateTenantReq: updateRequest,
      tenantId,
      facilityId,
      tenantToken
    });
    if (updateContactDetailsErr) {
      console.error("Update contact details error", updateContactDetailsErr);
      setHasError(true);
      return;
    }
    setIsLoading(false);
    navigate(currPage);
  };

  const props = {
    address,
    email,
    name,
    phone,
    callBackHandler,
    alternateEmail: other_address?.alternate_contact?.email || ""
  };

  return (
    <>
      {isLoading ? (
        showErrorScreen()
      ) : (
        <>
          {/* {isSubmitted && <UpdateNotifications status={isSuccessFull} />} */}
          <div className="updateContactDetailsParent">
            <UpdateContactDetails {...props} />
          </div>
        </>
      )}
    </>
  );
};
